import { createSlice } from '@reduxjs/toolkit';
import navigationService from 'navigation';
import apiClient from '@miroculus/api-client';
import { toast } from 'react-toastify';
import { instrumentDetailsUrl } from '../../constants/routes';
const initialState = {
    runs: [],
    loading: false,
    saving: false,
    selectedRunId: null,
};
/**
 * Receives an array of runs with "reagentExpirationDate" as timestamp and return
 * the runs with "reagentExpirationDate" as Date
 */
const castReagentExpirationDate = (runs) => runs.map((r) => r.reagentExpirationDate
    ? {
        ...r,
        reagentExpirationDate: new Date(r.reagentExpirationDate),
    }
    : r);
const runsSlice = createSlice({
    name: 'runs',
    initialState,
    reducers: {
        updateRuns: (state, action) => {
            state.runs = action.payload;
        },
        updateSelectedRunId: (state, action) => {
            state.selectedRunId = action.payload;
        },
        updateLoading: (state, action) => {
            state.loading = action.payload;
        },
        updateSaving: (state, action) => {
            state.saving = action.payload;
        },
    },
});
// Export actions
export const { updateRuns, updateSelectedRunId, updateLoading, updateSaving } = runsSlice.actions;
// Async thunks
export const loadDeviceRuns = (deviceId) => async (dispatch) => {
    dispatch(updateLoading(true));
    try {
        const { body } = await apiClient.get('/protocol-runs', {
            device: deviceId,
        });
        dispatch(updateRuns(castReagentExpirationDate(body)));
    }
    catch (e) {
        console.error(e);
        toast.error('There was a problem loading the device runs history.');
    }
    dispatch(updateLoading(false));
};
export const updateRunInformation = ({ values, deviceId, orgSlug }) => async (dispatch, getState) => {
    const { runs: { selectedRunId, runs }, } = getState();
    dispatch(updateSaving(true));
    try {
        await apiClient.put(`/protocol-runs/${selectedRunId}`, {
            ...values,
            reagentExpirationDate: values?.reagentExpirationDate?.getTime(),
        });
        const runIndex = runs.findIndex((r) => r.id === selectedRunId);
        dispatch(updateRuns([
            ...runs.slice(0, runIndex),
            {
                ...runs[runIndex],
                ...values,
            },
            ...runs.slice(runIndex + 1),
        ]));
        navigationService.push(instrumentDetailsUrl(orgSlug, deviceId));
        toast.success('The run information was successfully updated!');
    }
    catch (e) {
        console.error(e);
        toast.error('There was an error submitting the run information');
    }
    dispatch(updateSaving(false));
};
export const loadRunInformation = (deviceId, runId) => async (dispatch, getState) => {
    const { runs: { runs }, } = getState();
    // this in order to prevent an unnecessary request, however there are some edge cases
    // not covered by this check, e.g. a device with no runs
    if (!runs.length) {
        await dispatch(loadDeviceRuns(deviceId));
    }
    dispatch(updateSelectedRunId(Number(runId)));
};
// Export reducer as default
export default runsSlice.reducer;
